export default {
    COMPANY_SETTING: {
        VIEW: 'COMPANY-SETTING-VIEW',
        UPDATE: 'COMPANY-SETTING-UPDATE'
    },
    DASHBOARD: {
        VIEW: 'DASHBOARD-VIEW'
    },
    ATTENDANCE: {
        VIEW: 'ATTENDANCE-VIEW',
        UPDATE: 'ATTENDANCE-UPDATE'
    },
    DEVICE_MANAGEMENT: {
        VIEW: 'DEVICE-MANAGEMENT-VIEW',
        UPDATE: 'DEVICE-MANAGEMENT-UPDATE'
    },
    EMPLOYEE_MANAGEMENT: {
        VIEW: 'EMPLOYEE-MANAGEMENT-VIEW',
        UPDATE: 'EMPLOYEE-MANAGEMENT-UPDATE'
    },
    TIMETABLE_SETTING: {
        VIEW: 'TIMETABLE-SETTING-VIEW',
        UPDATE: 'TIMETABLE-SETTING-UPDATE'
    },
    VISITOR: {
        VIEW: 'VISITOR-VIEW',
        UPDATE: 'VISITOR-UPDATE'
    },
    BLACKLIST: {
        VIEW: 'BLACKLIST-VIEW',
        UPDATE: 'BLACKLIST-UPDATE'
    },
    NVR_PUNCH_LOG: {
        VIEW: 'NVR-PUNCH-LOG-VIEW'
    },
    ACTIVITY_LOG: {
        VIEW: 'ACTIVITY-LOG-VIEW'
    }
}
